import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/viewList/Home.vue';
import Layout from '@/components/header/Layout.vue';
import store from '../store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(VueRouter);

const routes = [{
    path: '/',
    redirect: '/home',
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [{
        path: '/signin',
        name: 'signin',
        meta: {
          login: false,
        },
        component: () => import( /* webpackChunkName: "SignIn" */ '../views/auth/SignIn.vue')
      },
      {
        path: '/signpwd',
        name: 'signpwd',
        meta: {
          login: false,
        },
        component: () => import( /* webpackChunkName: "SignPwd" */ '../views/auth/SignPwd')
      },
      {
        path: '/signup',
        name: 'signup',
        meta: {
          login: false,
        },
        component: () => import( /* webpackChunkName: "SignUp" */ '../views/auth/SignUp.vue')
      },

      {
        path: '/home',
        name: 'home',
        meta: {
          login: false,
        },
        component: Home
      },
      {
        path: '/serverCenter',
        name: 'serverCenter',
        meta: {
          login: false,
        },
        component: () => import( /* webpackChunkName: "serverCenter" */ '../views/viewList/serverCenter.vue'),
      },
      {
        path: '/serverDetail',
        name: 'serverDetail',
        meta: {
          login: false,
        },
        component: () => import( /* webpackChunkName: "serverDetail.vue" */
          '../views/serverCenterList/serverDetail.vue'),
      },
      {
        path: '/personCenter',
        name: 'personCenter',
        meta: {
          login: true,
        },
        component: () => import( /* webpackChunkName: "personCenter" */ '../views/viewList/personCenter.vue')
      },
      {
        path: '/applyService',
        name: 'applyService',
        meta: {
          login: true,
        },
        component: () => import( /* webpackChunkName: "serviceApply" */
          '../views/serverCenterList/serviceApply.vue'),
      },
      {
        path: '/footView',
        name: 'footView',
        meta: {
          login: false,
        },
        component: () => import( /* webpackChunkName: "serviceApply" */
          '../views/viewList/footView.vue'),
      }

    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})


// 导航守卫
router.beforeEach((to, from, next) => {
  // 登录注册无需检测是否登录状态
  if (to.meta.hasOwnProperty('login') && to.meta.login == false) {
    NProgress.start()
    return next();
  } else {
    try {
      if (!store.state.hasLogin) {
        return next('/signin');
      }
    } catch (e) {
      return next('/signin');
    }
  }

  NProgress.start()

  store.dispatch('updateUserData');
  store.dispatch('updateAllUsers');

  return next();
});


router.afterEach(() => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js